/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_S3Inputs */

const en_mk_tut_chat_s3 = /** @type {(inputs: Mk_Tut_Chat_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent replies **inside the thread** on your message rather than flooding the main channel.`)
};

const id_mk_tut_chat_s3 = /** @type {(inputs: Mk_Tut_Chat_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen membalas **di dalam thread** pesan Anda, bukan membanjiri channel utama.`)
};

/**
* | output |
* | --- |
* | "The agent replies **inside the thread** on your message rather than flooding the main channel." |
*
* @param {Mk_Tut_Chat_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_s3 = /** @type {((inputs?: Mk_Tut_Chat_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_s3(inputs)
	return en_mk_tut_chat_s3(inputs)
});